import React from 'react';
import AuraCardShell from './AuraCardShell';
import { AuraFormattedText } from './AuraFormattedText';
import StrategyStepActions from '../advice/StrategyStepActions';

const StrategyCardContent = ({ card, visionId = null, showStepActions = true }) => {
  const steps = card.steps || [];
  const horizon = card.horizon || '3 months';

  return (
    <AuraCardShell type="strategy" title={card.title} badge={horizon}>
      {card.rationale && (
        <div className="mb-3 text-body text-secondary">
          <AuraFormattedText content={card.rationale} />
        </div>
      )}
      <ol className="hairline-list space-y-0">
        {steps.map((step, idx) => {
          const isString = typeof step === 'string';
          const order = isString ? idx + 1 : step.order ?? idx + 1;
          const title = isString ? step : step.title || '';
          const detail = isString ? '' : step.detail;
          return (
            <li key={`${order}-${title}`} className="flex gap-3 py-3 first:pt-0">
              <span className="flex h-7 w-7 shrink-0 items-center justify-center rounded-full bg-pine text-primary text-label figure">
                {order}
              </span>
              <div className="min-w-0 flex-1">
                <p className="text-body font-medium text-primary">{title}</p>
                {detail && (
                  <p className="text-label text-secondary mt-1 leading-relaxed">{detail}</p>
                )}
                {!isString && step.target_date && (
                  <p className="text-label text-faint mt-1">Target: {step.target_date}</p>
                )}
                {showStepActions && (
                  <StrategyStepActions
                    step={step}
                    planTitle={card.title}
                    visionId={visionId}
                    sourceSurface="vision"
                  />
                )}
              </div>
            </li>
          );
        })}
      </ol>
    </AuraCardShell>
  );
};

export default StrategyCardContent;
